import React from "react";
import { Row, Col, Button } from "reactstrap";
import Datatable from "../Constants/Datatable";
import moment from "moment";
import {IRegistration,IGradeSelected, IPassword, IGrades } from './../Constants/Interfaces';
import {SEARCH_ICON} from './../Constants/SrcImages';
import ClipLoader from "react-spinners/ClipLoader";
import { css } from "@emotion/core";
const override = css`
  margin: 0 auto;
  position: relative;
  top: 10px;
  right: 10px;
`;
///--------->ADMIN<---------////
export function COLUMNS_ADMIN_PASSWORD(handlerPassword:(cell: number, row: IPassword) => JSX.Element) {
  return [
    {
      dataField: "per_id",
      headerAlign: 'center',
      text: "ID",
      formatter: handlerPassword
    },
    {
      dataField: "per_cedula",
      headerAlign: 'center',
      text: "Cédula"
    },
    {
      dataField: "per_name",
      text: "Nombre",
      headerAlign: 'center',
      formatter: (cell: number, row: IPassword) => `${row.per_name} ${row.per_lastname}`
    },
    {
      dataField: "per_password",
      headerAlign: 'center',
      text: "Contraseña"
    },
  ];
}

export function COLUMNS_LIST_PERSON_CONTA(columnsOptions) {
  return [
    {
      dataField: "per_id",
      text: "ID"
    },
    {
      dataField: "per_name",
      headerAlign: 'center',
      classes: 'text-right',
      text: "Nombre"
    },
    {
      dataField: "per_cedula",
      headerAlign: 'center',
      classes: 'text-center',
      text: "Cedula"
    },
    {
      dataField: "per_options",
      headerAlign: 'center',
      classes: 'text-center',
      text: "Opciones",
      formatter:columnsOptions
    },
  ];
}

export function COLUMNS_RTD_PAGO(columnModalEditTpago) {
  return [
    {
      dataField: "rpd_id",
      text: "ID",
      formatter:columnModalEditTpago
    },
    {
      dataField: "rpd_monto",
      headerAlign: 'center',
      classes: 'text-right',
      text: "Monto"
    },
    {
      dataField: "tp_desc",
      headerAlign: 'center',
      classes: 'text-center',
      text: "Tipo de pago"
    }
  ];
}

export function COLUMNS_CONTA_MONTO_DATES(columnModalEditDates) {
  return [
    {
      dataField: "mtd_mes_number",
      text: "MENSUALIDADES",
      formatter:columnModalEditDates
    },
    {
      dataField: "mtd_date",
      headerAlign: 'center',
      classes: 'text-center',
      text: "Fecha"
    }
  ];
}

export function COLUMNS_CXC_CUOTA_ECUENTA() {
  return [
    {
      dataField: "mtd_mes_number",
      text: "Cuota #",
      headerAlign: 'center',
      formatter: (cell: number, row: any) => `(`+row.mtd_mes_number+`) `+row.mtd_date,
      classes: 'text-left',
    },
    {
      dataField: "cxc_mes",
      text: "Cuota $$",
      headerAlign: 'center',
      formatter: (cell: number, row: any) => `B/. ${row.cxc_mes}`,
      classes: 'text-right',
    },
    {
      dataField: "cxc_stado",
      text: "Cuota Estado",
      headerAlign: 'center',
      classes: 'text-center',
    },
    {
      dataField: "cxc_saldo",
      text: "Recargo por morosidad 10%",
      headerAlign: 'center',
      formatter: (cell: number, row: any) => {
        var cxcmoro = 0;    
        if(row.cxc_morostado==="Debe"){
          if (moment(row.mtd_date).format("YYYY-MM-DD") < moment(new Date()).format("YYYY-MM-DD")){
            if(Number(row.cxc_saldo)>0){
              cxcmoro = Number(row.cxc_saldo) * 0.10
            }
            else{
              cxcmoro =  Number(row.cxc_mes) * 0.10
            }
            
          }
          else{
            cxcmoro = 0;
          }
        }
        else{
          cxcmoro = 0;
        }
        return `B/. ${cxcmoro.toFixed(2)}`
      },
      classes: 'text-right',
    }
    ,
    {
      dataField: "cxc_morostado",
      text: "Morosidad Estado",
      headerAlign: 'center',
      classes: 'text-center',
    }
  ];
}

export function COLUMNS_CXC_TYPE_ECUENTA() {
  return [
    {
      dataField: "cxcd_type_desc",
      headerAlign: 'center',
      classes: 'text-center',
      text: "Tipo"
    },
    {
      dataField: "cxcd_monto",
      headerAlign: 'center',
      classes: 'text-right',
      formatter: (cell: number, row: any) => `B/. ${row.cxcd_monto}`,
      text: "Monto",
    },
    {
      dataField: "cxcs_desc",
      headerAlign: 'center',
      classes: 'text-center',
      text: "Estado"
    },
  ];
}

export function COLUMNS_ADMIN_ANNOUNCEMENT(handleOptionsAnuncio,handleImageAnuncio,handleEditAnuncio) {
  return [
    {
      dataField: "ad_id",
      headerAlign: 'center',
      text: "ID",
      formatter: handleEditAnuncio
    },

    {
      dataField: "ad_desc",
      headerAlign: 'center',
      text: "Descripción",
    },
    {
      dataField: "ad_date",
      headerAlign: 'center',
      text: "Fecha"
    },
    {
      dataField: "ad_img",
      headerAlign: 'center',
      text: "Imagen",
      formatter: handleImageAnuncio
    },
    {
      dataField: "ad_options",
      headerAlign: 'center',
      text: "Opciones",
      formatter: handleOptionsAnuncio
    },
  ];
}

export function COLUMNS_ADMIN_GRADES_CONTA(columnModalSearchCuentas) {
  return [
    {
      dataField: "gr_id",
      text: "ID",
      formatter: columnModalSearchCuentas
    },
    {
      dataField: "gr_desc",
      text: "Grado",
    },
  ];
}

export function COLUMNS_ADMIN_GRADES(handleModalEditPerson: (cell: number, row: IGrades) => JSX.Element) {
  return [
    {
      dataField: "gr_id",
      headerAlign: 'center',
      text: "ID",
      formatter: handleModalEditPerson
    },
    {
      dataField: "gr_desc",
      headerAlign: 'center',
      text: "Grado",
      formatter: (cell: number, row: IGrades) => `${row.gr_desc} ${row.gr_alias}`
    },
    {
      dataField: "cy_desc",
      headerAlign: 'center',
      text: "Ciclo",
    },
  ];
}

export function COLUMNS_CONSEJERIA_HABITOS(dropHabito,observacionHabito,bh_id,bh_observacion) {
  return [
    {
      dataField: "per_name",
      text: "Estudiante",
      formatter: (cell: any, row: { per_name: any; per_lastname: any; }) => `${row.per_name} ${row.per_lastname}`,
      headerClasses: 'w-250 column-dark',
      classes: 'lh-35 column-dark',
    },
    {
      dataField: "bh_respect",
      text: "Respect",
      formatter: dropHabito,
      headerClasses: 'column-dark',
      formatExtraData: {
        dataField: "bh_respect",
      }
    },
    {
      dataField: "bh_order_neather",
      text: "Order and Neatnes",
      headerClasses: 'column-dark',
      formatter: dropHabito,
      formatExtraData: {
        dataField: "bh_order_neather",
      }
    },
    {
      dataField: "bh_respons",
      text: "Respons",
      formatter: dropHabito,
      headerClasses: 'column-dark',
      formatExtraData: {
        dataField: "bh_respons",
      }
    },
    {
      dataField: "bh_civism",
      text: "Civismo",
      formatter: dropHabito,
      headerClasses: 'column-dark',
      formatExtraData: {
        dataField: "bh_civism",
      }
    },
    {
      dataField: "bh_honesty",
      text: "Honesty",
      formatter: dropHabito,
      headerClasses: 'column-dark',
      formatExtraData: {
        dataField: "bh_honesty",
      }
    },
    {
      dataField: "bh_coopera",
      text: "Coopera",
      formatter: dropHabito,
      headerClasses: 'column-dark',
      formatExtraData: {
        dataField: "bh_coopera",
      }
    },
    {
      dataField: "bh_manners",
      text: "Manners",
      formatter: dropHabito,
      headerClasses: 'column-dark',
      formatExtraData: {
        dataField: "bh_manners",
      }
    },
    {
      dataField: "bh_puntual",
      text: "Puntual",
      formatter: dropHabito,
      headerClasses: 'column-dark',
      formatExtraData: {
        dataField: "bh_puntual",
      }
    },
    {
      dataField: "bh_selfcont",
      text: "Selfcont",
      formatter: dropHabito,
      headerClasses: 'column-dark',
      formatExtraData: {
        dataField: "bh_selfcont",
      }
    },
    {
      dataField: "bh_observacion",
      text: "Observacion",
      headerClasses: 'w-200 column-dark',
      formatter:observacionHabito,
      formatExtraData: {
        bh_id:bh_id,
        observacion: bh_observacion,
      }
    }
  ];
}

export function COLUMNS_CXCDETAIL_ACU(handleEditCuota,label_cxc_mes,label_cxc_saldo,label_cxc_moro) {
  return [
    {
      dataField: "cxc_cuota",
      text: "Cuota #",
      formatter: handleEditCuota
    },
    {
      dataField: "cxc_mes",
      text: "Cuota colegiatura $$",
      headerAlign: 'center',
      classes: 'text-right',
      formatter: label_cxc_mes
    },
    {
      dataField: "mtd_date",
      text: "Fecha de pago",
      headerAlign: 'center',
      classes: 'text-center',
    },
    {
      dataField: "cxc_moro",
      text: "Recargo por Morosidad 10%",
      headerAlign: 'center',
      classes: 'text-right',
      formatter: label_cxc_moro
    }
  ];
}

export function COLUMNS_CXCDETAIL(handleEditCuota,label_cxc_mes,label_cxc_saldo) {
  return [
    {
      dataField: "cxc_cuota",
      text: "Cuota #",
      formatter: handleEditCuota
    },
    {
      dataField: "cxc_mes",
      text: "Monto",
      headerAlign: 'center',
      classes: 'text-right',
      formatter: label_cxc_mes
    },
    {
      dataField: "me_stado",
      text: "Cuota estado",
      headerAlign: 'center',
      classes: 'text-center',
    },
    {
      dataField: "cxc_saldo",
      text: "Por Pagar",
      headerAlign: 'center',
      classes: 'text-right',
      formatter: label_cxc_saldo
    },
    // {
    //   dataField: "cxc_moro",
    //   text: "Morosidad",
    //   headerAlign: 'center',
    //   classes: 'text-right',
    //   // formatter: label_cxc_moro
    // },
    {
      dataField: "moro_stado",
      text: "Morosidad estado",
      headerAlign: 'center',
      classes: 'text-center',
    }
  ];
}

export function COLUMNS_CONSEJERIA() {
  return [
    {
      dataField: "per_name",
      text: "NOMBRE",
      headerClasses: 'w-250 column-dark',
      // classes: 'font-weight-bold',
      formatter: (cell: any, row: { per_name: any; per_lastname: any; }) => `${row.per_name} ${row.per_lastname}`,
    },
    {
      dataField: "per_cedula",
      text: "CÉDULA",
      headerAlign: 'center',
      headerClasses: "hw-150 column-dark",
      align: 'center',
      searchable: true
    }
  ];
}

export function COLUMNS_ESTUDENT() {
  return [
    {
      dataField: "per_name",
      text: "Nombre",
      headerAlign: 'center',
      formatter: (cell: any, row: { per_name: any; }) => <React.Fragment>
        <Row>
          <Col xs={12} className="d-flex">
          {row.per_name}
<img className="img-status img-search" src={SEARCH_ICON} alt="" />
          </Col>
        </Row>
      
      </React.Fragment>,
    },
    {
      dataField: "per_cedula",
      headerAlign: 'center',
      text: "Cédula",
      align: 'center'
    }
  ];
}

export function COLUMNS_PERSON_CORREO(handlerStudent,handlerSendACorreo) {
  return [
    {
      dataField: "per_cedula",
      headerAlign: 'center',
      text: "Cédula",
    },
    {
      dataField: "per_name",
      headerAlign: 'center',
      text: "Nombre",
      formatter: (cell: any, row: { per_name: any; per_lastname: any; }) => `${row.per_name} ${row.per_lastname}`,
    },
    {
      dataField: "per_email",
      headerAlign: 'center',
      text: "Email",
    },
    {
      dataField: "handlerStudent",
      headerAlign: 'center',
      text: "Estudiante",
      formatter: handlerStudent
    },
    {
      dataField: "handlerSendCorreo",
      headerAlign: 'center',
      text: "Reenviar",
      formatter: handlerSendACorreo
    },
  ];
}

export function COLUMNS_PERSON(handleModalEditPerson: (cell: any, row: any) => JSX.Element) {
  return [
    {
      dataField: "per_id",
      headerAlign: 'center',
      text: "ID",
      formatter: handleModalEditPerson
    },
    {
      dataField: "per_cedula",
      headerAlign: 'center',
      text: "Cédula",
    },
    {
      dataField: "per_name",
      headerAlign: 'center',
      text: "Nombre",
      formatter: (cell: any, row: { per_name: any; per_lastname: any; }) => `${row.per_name} ${row.per_lastname}`,
    },
    {
      dataField: "typ_desc",
      headerAlign: 'center',
      text: "Tipo",
    },
    {
      dataField: "per_celphone1",
      headerAlign: 'center',
      text: "Teléfono",
    },
    {
      dataField: "per_email",
      headerAlign: 'center',
      text: "Email",
    },
  ];
}

export function COLUMNS_ASIGNATURE(handlerAddSubmateria: any,columnModalEditAsignarture:any) {
  return [
    {
      dataField: "as_id",
      text: "ID",
      headerAlign: 'center',
      classes: 'text-center',
    },
    {
      dataField: "as_desc",
      text: "Asignatura",
      headerAlign: 'center',
      classes: 'text-center',
      formatter: columnModalEditAsignarture
    },
    {
      dataField: "ar_desc",
      text: "Area",
      headerAlign: 'center',
      classes: 'text-center'
    },
    {
      dataField: "as_sub",
      text: "Submateria",
      formatter: handlerAddSubmateria,
      headerAlign: 'center',
      classes: 'text-center',
      style: {
        width: '500px'
      }
    },
  ];
}

export function COLUMNS_ASIGNATURE_PLANS() {
  return [
    {
      dataField: "pl_id",
      text: "ID",
      headerAlign: 'center',
      classes: 'text-center',
      style: {
        width: '100px'
      }
    },
    {
      dataField: "pl_desc",
      text: "Plan",
      headerAlign: 'center',
      classes: 'text-center'
    }
  ];
}

export function COLUMNS_ACONSEJERIA(handlerModalChangeConsejeria: (arg0: any) => void) {
  return [
    {
      dataField: "per_name",
      text: "Nombre",
      formatter: (cell: any, row: { per_name: any; per_lastname: any; }) => `Prof. ${row.per_name} ${row.per_lastname}`,
    },
    {
      dataField: "optionChange",
      text: "Opciones",
      formatter: (cell: any, row: any) => <Button color="danger" onClick={() => handlerModalChangeConsejeria(row)}>Cambiar</Button>,
      headerAlign: 'center',
      classes: 'text-center',
      style: {
        width: '250px'
      }
    },
  ];
}

export function COLUMNS_TEACHERS_EXPAND_ROW() {
  return [
    {
      dataField: "per_name",
      headerAlign: 'center',
      text: "Nombre del profesor"
    }
  ];
}


export function COLUMNS_TEACHERS(handlerOpen: any,handlerChange: any, handlerEditLink:any) {
  return [
    {
      dataField: "per_id",
      headerAlign: 'center',
      text: "ID",
    },
    {
      dataField: "per_name",
      headerAlign: 'center',
      text: "Nombre",
      formatter: (cell: any, row: { per_name: any; per_lastname: any; }) => `${row.per_name} ${row.per_lastname}`,
    },
    {
      dataField: "gr_desc",
      headerAlign: 'center',
      text: "Consejeria",
      formatter: (cell: any, row: { gr_desc: any; gr_alias: any; }) => `${row.gr_desc} ${row.gr_alias}`,
    },
    {
      dataField: "per_link",
      headerAlign: 'center',
      text: "Link personal",
      formatter: handlerEditLink,
    },
    {
      dataField: "option",
      headerAlign: 'center',
      text: "Acceso",
      formatter: handlerOpen
    },
    {
      dataField: "optionChange",
      headerAlign: 'center',
      text: "Puede modificar?",
      formatter: handlerChange
    },
  ];
}

export function COLUMNS_PLANS_MATERIASBYPLAN(handlerEdit:any) {
  return [
    {
      dataField: "as_id",
      text: "ID",
      formatter: handlerEdit
    },
    {
      dataField: "as_desc",
      text: "Materia",
      searchable: true
    }
  ];
}


export function COLUMNS_CXCDT(handleEditTypeDetalle,label_cxcd_monto,label_cxcd_saldo) {
  return [
    {
      dataField: "cxct_desc",
      text: "Tipo",
      searchable: true,
      formatter: handleEditTypeDetalle
    },
    {
      dataField: "cxcd_monto",
      text: "Monto",
      searchable: true,
      headerAlign: 'center',
      classes: 'text-right',
      formatter: label_cxcd_monto
    },
    {
      dataField: "cxcs_desc",
      text: "Estado",
      searchable: true,
      headerAlign: 'center',
      classes: 'text-center'
    },
    {
      dataField: "cxcd_saldo",
      text: "Saldo",
      searchable: true,
      headerAlign: 'center',
      classes: 'text-right',
      formatter: label_cxcd_saldo
    }
  ];
}

export function COLUMNS_PLANS(handlerEdit: any) {
  return [
    {
      dataField: "pl_id",
      text: "ID",
      headerAlign: 'center',
      formatter: handlerEdit
    },
    {
      dataField: "pl_desc",
      headerAlign: 'center',
      text: "Plan"
    },
    {
      dataField: "cy_desc",
      headerAlign: 'center',
      text: "Ciclo"
    }
  ];
}


export function COLUMNS_CYCLES_AREA() {
  return [
    {
      dataField: "cy_id",
      text: "ID",
      headerAlign: 'center',
    },
    {
      dataField: "cy_desc",
      headerAlign: 'center',
      text: "Ciclo"  
    }
  ];
}

export function COLUMNS_CYCLES(handlerEdit: any) {
  return [
    {
      dataField: "cy_id",
      text: "ID",
      headerAlign: 'center',
      formatter: handlerEdit
    },
    {
      dataField: "cy_desc",
      headerAlign: 'center',
      text: "Cédula"  
    }
  ];
}

export function COLUMNS_RETIRED() {
  return [
    {
      dataField: "per_cedula",
      headerAlign: 'center',
      text: "Cédula",
    },
    {
      dataField: "per_name",
      headerAlign: 'center',
      text: "Nombre",
      formatter: (cell: any, row: { per_name: any; per_lastname: any; }) => `${row.per_name} ${row.per_lastname}`,
    },
    {
      dataField: "reg_grade",
      headerAlign: 'center',
      text: "Grado"
    },
    {
      dataField: "reg_retreason",
      headerAlign: 'center',
      text: "Motivo"
    }
  ];
}

export function COLUMNS_GRADES_ACONSEJERIA() {
  return [
    {
      dataField: "gr_desc",
      text: "Grado",
      formatter: (cell: any, row: { gr_desc: any; gr_alias: any; }) => `${row.gr_desc} (${row.gr_alias})`,
    },
  ];
}

export function COLUMNS_CXCCOBRAR() {
  return [
    {
      dataField: "cxc_cuota",
      headerAlign: 'center',
      text: "# CUOTA",
    },
    {
      dataField: "cxc_mes",
      headerAlign: 'center',
      text: "Monto",
      formatter: (cell: any, row: { gr_desc: any; gr_alias: any; }) => `${row.gr_desc} (${row.gr_alias})`,
    },
  ];
}

export function COLUMNS_GRADES() {
  return [
    {
      dataField: "gr_id",
      headerAlign: 'center',
      text: "ID",
    },
    {
      dataField: "gr_desc",
      headerAlign: 'center',
      text: "Grado",
      formatter: (cell: any, row: { gr_desc: any; gr_alias: any; }) => `${row.gr_desc} (${row.gr_alias})`,
    },
  ];
}

export function COLUMNS_REGISTRATION(editRegistration,handlerRegistration: (cell: any, row: any) => JSX.Element) {
  return [
    {
      dataField: "per_cedula",
      text: "Cédula",
      classes: 'text-center',
      headerAlign: 'center',
      formatter: editRegistration,
    },
    {
      dataField: "per_lastname",
      classes: 'text-center',
      headerAlign: 'center',
      text: "Apellido",
    },
    {
      dataField: "per_name",
      classes: 'text-center',
      headerAlign: 'center',
      text: "Nombre",
    },
    {
      dataField: "per_birthday",
      text: "Edad",
      headerAlign: 'center',
      classes: 'text-center',
      formatter: (cell: any, row: { per_birthday: moment.MomentInput; }) => `${moment().diff(row.per_birthday, "years")}`,
    },
    {
      dataField: "reg_new",
      text: "Nuevo",
      headerAlign: 'center',
      classes: 'text-center',
      formatter: (cell: any, row: { reg_new: string; }) => (row.reg_new === "1" ? "SI" : "NO"),
    },
    {
      dataField: "reg_complete",
      text: "Completo",
      headerAlign: 'center',
      classes: 'text-center',
      formatter: (cell: any, row: { reg_complete: string; }) => (row.reg_complete === "1" ? "SI" : "NO"),
    },
    {
      dataField: "reg_options",
      text: "Opciones",
      classes: 'text-center',
      headerAlign: 'center',
      formatter: handlerRegistration,
    },
  ];
}

export function EXPAND_ROW_CXDDETAIL_ACU(
  dataCxcDetailType: any,
  handleAddCxcDetalle:any,
  handlerSearchDetalle:any,
  handleEditTypeDetalle:any,
  label_cxcd_monto:any,
  label_cxcd_saldo:any
  ) {
  return {
    parentClassName: "bg-row-parent",
    className: "bg-row-body",
    onlyOneExpanding: true,
    renderer: (row: any) => (
      <React.Fragment>
        <Row>
          <Col sm={12} className="datatable-cxc">
            <Datatable
              data={dataCxcDetailType}
              columns={COLUMNS_CXCDT(handleEditTypeDetalle,label_cxcd_monto,label_cxcd_saldo)}
              keyProp="cxcd_id"
              exportD={false}
              searchs={false}
              selectRows={false}
              optionSelectRow={null}
            />
          </Col>
        </Row>
      </React.Fragment>
    ),
    onExpand: (row: { cxc_id: any;}, isExpand: any, rowIndex: any, e: any) => {
      if (isExpand) {
        handlerSearchDetalle(row.cxc_id);
      }
    }
  };
}

export function EXPAND_ROW_CXDDETAIL(
  dataCxcDetailType: any,
  handleAddCxcDetalle:any,
  handlerSearchDetalle:any,
  handleEditTypeDetalle:any,
  label_cxcd_monto:any,
  label_cxcd_saldo:any,
  ) {
  return {
    parentClassName: "bg-row-parent",
    className: "bg-row-body",
    onlyOneExpanding: true,
    renderer: (row: any) => (
      <React.Fragment>
        <Row>
          <Col sm={6}>
          </Col>
          <Col sm={6} className="text-right">
            <Button color="success" onClick={() => handleAddCxcDetalle()}>
              Agregar
            </Button>
          </Col>
        </Row>
        <Row>
          <Col sm={12} className="datatable-cxc">
            <Datatable
              data={dataCxcDetailType}
              columns={COLUMNS_CXCDT(handleEditTypeDetalle,label_cxcd_monto,label_cxcd_saldo)}
              keyProp="cxcd_id"
              exportD={false}
              searchs={false}
              selectRows={false}
              optionSelectRow={null}
            />
          </Col>
        </Row>
      </React.Fragment>
    ),
    onExpand: (row: { cxc_id: any;}, isExpand: any, rowIndex: any, e: any) => {
      if (isExpand) {
        handlerSearchDetalle(row.cxc_id);
      }
    }
  };
}

export function EXPAND_ROW_PLAN_MATERIA(
  loading:boolean,
  rechargeData: { (): void; (): void; },
  fetchAsignatureByPlan:any,
  dataAsignatureByPlan: any,
  handlerAddMateria:any,
  handleAddAsignature: { (): void; (): void; },
  handlerEdit:any) {
  return {
    parentClassName: "bg-row-parent",
    className: "bg-row-body",
    onlyOneExpanding: true,
    renderer: (row: any) => (
      <React.Fragment>
        <Row className="mb-3">
          <Col sm={6}>
          </Col>
          <Col sm={6} className="text-right">
            <ClipLoader css={override} size={23} color={"#36D7B7"} loading={loading} />
            <Button color="primary" className="mr-2" onClick={() => rechargeData()}>
              Recargar
            </Button>
            <Button color="success" onClick={() => handleAddAsignature()}>
              Agregar
            </Button>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <Datatable
              data={dataAsignatureByPlan}
              columns={COLUMNS_PLANS_MATERIASBYPLAN(handlerEdit)}
              keyProp="sp_id"
              exportD={false}
              searchs={false}
              selectRows={false}
              optionSelectRow={null}
            />
          </Col>
        </Row>
      </React.Fragment>
    ),
    onExpand: (row: { pl_id: any; pl_desc: any; }, isExpand: any, rowIndex: any, e: any) => {
      if (isExpand) {
        fetchAsignatureByPlan({pl_id:row.pl_id,pl_desc:row.pl_desc});
      }
    }
  };
}

export function EXPAND_ROW_GRADE(
  loading:boolean,
  rechargeData: { (): void; (): void; },
  fetchRegistration: { ({ gr_id, gr_desc }: IGradeSelected)},
  dataRegistration: IRegistration[],
  handleImport: { (): void; (): void; },
  handleAddRegitration: { (): void; (): void; },
  editRegistration:any,
  registrationHandleOptions: (cell: any, row: any) => JSX.Element) {
  return {
    parentClassName: "bg-row-parent",
    className: "bg-row-body",
    onlyOneExpanding: true,
    renderer: (row: any) => (
      <React.Fragment>
        <Row className="mb-3">
          <Col sm={6}>
            <Button color="info" onClick={() => handleImport()}>
              Importar
            </Button>
          </Col>
          <Col sm={6} className="text-right">
            <ClipLoader css={override} size={23} color={"#36D7B7"} loading={loading} />
            <Button color="primary" className="mr-2" onClick={() => rechargeData()}>
              Recargar
            </Button>
            <Button color="success" onClick={() => handleAddRegitration()}>
              Nuevo
            </Button>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <Datatable
              data={dataRegistration}
              columns={COLUMNS_REGISTRATION(editRegistration,registrationHandleOptions)}
              keyProp="reg_id"
              exportD={false}
              searchs={true}
              selectRows={false}
              optionSelectRow={false}
            />
          </Col>
        </Row>
      </React.Fragment>
    ),
    onExpand: (row: { gr_id: any; gr_desc: any; }, isExpand: any, rowIndex: any, e: any) => {
      if (isExpand) {
        fetchRegistration({gr_id:row.gr_id,gr_desc:row.gr_desc});
      }
    }
  };
}

export function COLUMNS_REGISTRATION_CUENTAS(columnModalSearchCuentas) {
  return [
    {
      dataField: "per_cedula",
      text: "Cédula",
      formatter: columnModalSearchCuentas,
    },
    {
      dataField: "per_lastname",
      text: "Apellido",
    },
    {
      dataField: "per_name",
      text: "Nombre",
    }
  ];
}

export function COLUMNS_REGISTRATION_BOLETINES(handlerGetArreglo:any) {
  return [
    {
      dataField: "per_cedula",
      text: "Cédula",
      formatter:handlerGetArreglo
    },
    {
      dataField: "per_lastname",
      text: "Apellido",
    },
    {
      dataField: "per_name",
      text: "Nombre",
    }
  ];
}

export function COLUMNS_REGISTRATION_ACTIVATION_APAGO(handlerGetArreglo:any) {
  return [
    {
      dataField: "per_cedula",
      headerAlign: 'center',
      text: "Cédula",
      formatter: handlerGetArreglo,
    },
    {
      dataField: "per_lastname",
      text: "Apellido",
    },
    {
      dataField: "per_name",
      text: "Nombre",
    }
  ];
}
export function COLUMNS_REGISTRATION_ACTIVATION_ECUENTA(handlerGetECuenta:any) {
  return [
    {
      dataField: "per_cedula",
      headerAlign: 'center',
      text: "Cédula",
      formatter: handlerGetECuenta,
    },
    {
      dataField: "per_lastname",
      text: "Apellido",
    },
    {
      dataField: "per_name",
      text: "Nombre",
    }
  ];
}

export function COLUMNS_REGISTRATION_ACTIVATION(handlerRegistration: (cell: any, row: any) => JSX.Element) {
  return [
    {
      dataField: "per_cedula",
      headerAlign: 'center',
      text: "Cédula",
    },
    {
      dataField: "per_lastname",
      text: "Apellido",
    },
    {
      dataField: "per_name",
      text: "Nombre",
    },
    {
      dataField: "reg_options",
      text: "Opciones",
      formatter: handlerRegistration,
      headerAlign: 'center',
      classes: 'text-center',
      style: {
        width: '250px'
      }
    },
  ];
}

export function COLUMNS_HOUR_STUDENT() {
  return [
    {
      dataField: "h_hour",
      text: "Hora",
      formatter: (cell: any, row: { hr_hourstart: any; hr_hourend: any; }) => `${moment(row.hr_hourstart).format("hh:mm")} - ${moment(row.hr_hourend).format("hh:mm")}`,
    },
    {
      dataField: "asdesc_lunes",
      text: "Lunes",
    },
    {
      dataField: "asdesc_martes",
      text: "Martes",
    },
    {
      dataField: "asdesc_miercoles",
      text: "Miercoles",
    },
    {
      dataField: "asdesc_jueves",
      text: "Jueves",
    },
    {
      dataField: "asdesc_viernes",
      text: "Viernes",
    }
  ];
}

export function COLUMNS_HOUR_ASITEACHER(columnModalEditHour) {
  return [
    {
      dataField: "tas_periodo",
      headerAlign: 'center',
      text: "Periodo",
      formatter: columnModalEditHour
    },
    {
      dataField: "h_hour",
      headerAlign: 'center',
      text: "Hora",
      formatter: (cell: any, row: { tas_hourstar: any; tas_hourend: any; }) => `${moment(row.tas_hourstar).format("hh:mm")} - ${moment(row.tas_hourend).format("hh:mm")}`,
    },
    {
      dataField: "asdesc_lunes",
      headerAlign: 'center',
      text: "Lunes",
      formatter: (cell: any, row: { asdesc_lunes:any;grdesc_lunes: any;}) => row.asdesc_lunes !== null || row.grdesc_lunes !== null ? `${row.asdesc_lunes} (${row.grdesc_lunes})`: null 
    },
    {
      dataField: "asdesc_martes",
      headerAlign: 'center',
      text: "Martes",
      formatter: (cell: any, row: {asdesc_martes:any; grdesc_martes: any;}) => row.asdesc_martes !== null || row.grdesc_martes !== null ? `${row.asdesc_martes} (${row.grdesc_martes})`: null
    },
    {
      dataField: "asdesc_miercoles",
      headerAlign: 'center',
      text: "Miercoles",
      formatter: (cell: any, row: { asdesc_miercoles:any;grdesc_miercoles: any;}) =>  row.asdesc_miercoles !== null || row.grdesc_miercoles !== null ? `${row.asdesc_miercoles} (${row.grdesc_miercoles})`: null
    },
    {
      dataField: "asdesc_jueves",
      headerAlign: 'center',
      text: "Jueves",
      formatter: (cell: any, row: {asdesc_jueves:any; grdesc_jueves: any;}) =>  row.asdesc_jueves !== null || row.grdesc_jueves !== null ? `${row.asdesc_jueves} (${row.grdesc_jueves})`: null 
    },
    {
      dataField: "asdesc_viernes",
      headerAlign: 'center',
      text: "Viernes",
      formatter: (cell: any, row: {asdesc_viernes:any; grdesc_viernes: any;}) => row.asdesc_viernes !== null || row.grdesc_viernes !== null ? `${row.asdesc_viernes} (${row.grdesc_viernes})`: null 
      
    }
  ];
}

export function COLUMNS_AREA_BYCYCLE(columnsEditArea) {
  return [
    {
      dataField: "ar_id",
      text: "Area",
      headerAlign: 'center',
      formatter:columnsEditArea
    },
    {
      dataField: "ar_desc",
      classes: 'text-left',
      text: "Descripción",
      headerAlign: 'center',
    },
    {
      dataField: "ar_sort",
      classes: 'text-center',
      headerAlign: 'center',
      text: "Orden boletin",
    }
  ];
}

export function COLUMNS_HOUR(columnModalEditHour) {
  return [
    {
      dataField: "hr_periodo",
      text: "Periodo",
      headerAlign: 'center',
      formatter: columnModalEditHour,
      headerClasses: 'w-100px',
    },
    {
      dataField: "h_hour",
      text: "Hora",
      headerAlign: 'center',
      formatter: (cell: any, row: { hr_hourstart: any; hr_hourend: any; }) => `${moment(row.hr_hourstart).format("hh:mm")} - ${moment(row.hr_hourend).format("hh:mm")}`,
    },
    {
      dataField: "asdesc_lunes",
      headerAlign: 'center',
      text: "Lunes",
    },
    {
      dataField: "asdesc_martes",
      headerAlign: 'center',
      text: "Martes",
    },
    {
      dataField: "asdesc_miercoles",
      headerAlign: 'center',
      text: "Miercoles",
    },
    {
      dataField: "asdesc_jueves",
      headerAlign: 'center',
      text: "Jueves",
    },
    {
      dataField: "asdesc_viernes",
      headerAlign: 'center',
      text: "Viernes",
    }
  ];
}

export function EXPAND_ROW_GRADE_ACTIVATION(
  fetchRegistration: { ({ gr_id, gr_desc }: IGradeSelected)},
  dataRegistration: IRegistration[],
  registrationHandleOptions: (cell: any, row: any) => JSX.Element) {
  return {
    parentClassName: "bg-row-parent",
    className: "bg-row-body",
    onlyOneExpanding: true,
    renderer: (row: any) => (
      <React.Fragment>
        <Row>
          <Col sm={12}>
            <Datatable
              data={dataRegistration}
              columns={COLUMNS_REGISTRATION_ACTIVATION(registrationHandleOptions)}
              keyProp="reg_id"
              exportD={false}
              searchs={true}
              selectRows={false}
              optionSelectRow={null}
            />
          </Col>
        </Row>
      </React.Fragment>
    ),
    onExpand: (row: { gr_id: any; gr_desc: any; }, isExpand: any, rowIndex: any, e: any) => {
      if (isExpand) {
        fetchRegistration({gr_id:row.gr_id,gr_desc:row.gr_desc});
      }
    }
  };
}

export function COLUMNS_CXC_ECUENTAS(
  fetchType: any,
  dataCxc: any[]) {
  return {
    parentClassName: "bg-row-parent",
    className: "bg-row-body",
    onlyOneExpanding: true,
    renderer: (row: any) => (
      <React.Fragment>
        <Row>
          <Col sm={12}>
            <Datatable
              data={dataCxc}
              columns={COLUMNS_CXC_TYPE_ECUENTA()}
              keyProp="cxcd_id"
              exportD={false}
              searchs={false}
              selectRows={false}
              optionSelectRow={null}
            />
          </Col>
        </Row>
      </React.Fragment>
    ),
    onExpand: (row: { cxc_id: any;}, isExpand: any, rowIndex: any, e: any) => {
      if (isExpand) {
        fetchType({cxc_id:row.cxc_id});
      }
    }
  };
}

export function EXPAND_ROW_GRADE_A_PAGOS(
  fetchRegistration: { ({ gr_id, gr_desc }: IGradeSelected)},
  dataRegistration: IRegistration[],
  handlerGetArreglo:any) {
  return {
    parentClassName: "bg-row-parent",
    className: "bg-row-body",
    onlyOneExpanding: true,
    renderer: (row: any) => (
      <React.Fragment>
        <Row>
          <Col sm={12}>
            <Datatable
              data={dataRegistration}
              columns={COLUMNS_REGISTRATION_ACTIVATION_APAGO(handlerGetArreglo)}
              keyProp="reg_id"
              exportD={false}
              searchs={true}
              selectRows={false}
              optionSelectRow={null}
            />
          </Col>
        </Row>
      </React.Fragment>
    ),
    onExpand: (row: { gr_id: any; gr_desc: any; }, isExpand: any, rowIndex: any, e: any) => {
      if (isExpand) {
        fetchRegistration({gr_id:row.gr_id,gr_desc:row.gr_desc});
      }
    }
  };
}
export function EXPAN_ROW_COLUMNS_ACYCLE(
  fetchArea: { ({ cy_id, cy_desc }: any)},
  dataArea: any,
  addACycle:any,
  rechargeData:any,
  loading:any,
  columnsEditArea:any) {
  return {
    parentClassName: "bg-row-parent",
    className: "bg-row-body",
    onlyOneExpanding: true,
    renderer: (row: any) => (
      <React.Fragment>
        <Row>
          <Col xs={12} className="text-right">
          <ClipLoader css={override} size={23} color={"#36D7B7"} loading={loading} />
            <Button color="primary" className="mr-2" onClick={() => rechargeData()}>
              Recargar
            </Button>
          <Button color="success" onClick={() => addACycle()}>
            Agregar
          </Button>
          </Col>
          <Col sm={12}>
            <Datatable
              data={dataArea}
              columns={COLUMNS_AREA_BYCYCLE(columnsEditArea)}
              keyProp="ar_id"
              exportD={false}
              searchs={true}
              selectRows={false}
              optionSelectRow={null}
            />
          </Col>
        </Row>
      </React.Fragment>
    ),
    onExpand: (row: { cy_id: any; cy_desc: any; }, isExpand: any, rowIndex: any, e: any) => {
      if (isExpand) {
        fetchArea({cy_id:row.cy_id,cy_desc:row.cy_desc});
      }
    }
  };
}

export function EXPAND_ROW_GRADE_ACTIVATION_ECUENTA(
  fetchRegistration: { ({ gr_id, gr_desc }: IGradeSelected)},
  dataRegistration: IRegistration[],
  handlerGetECuenta:any) {
  return {
    parentClassName: "bg-row-parent",
    className: "bg-row-body",
    onlyOneExpanding: true,
    renderer: (row: any) => (
      <React.Fragment>
        <Row>
          <Col sm={12}>
            <Datatable
              data={dataRegistration}
              columns={COLUMNS_REGISTRATION_ACTIVATION_ECUENTA(handlerGetECuenta)}
              keyProp="reg_id"
              exportD={false}
              searchs={true}
              selectRows={false}
              optionSelectRow={null}
            />
          </Col>
        </Row>
      </React.Fragment>
    ),
    onExpand: (row: { gr_id: any; gr_desc: any; }, isExpand: any, rowIndex: any, e: any) => {
      if (isExpand) {
        fetchRegistration({gr_id:row.gr_id,gr_desc:row.gr_desc});
      }
    }
  };
}

export function EXPAND_ROW_GRADE_CUENTAS(
  fetchRegistration: { ({ gr_id, gr_desc }: IGradeSelected)},
  dataRegistration: IRegistration[],
  columnModalSearchCuentas) {
  return {
    parentClassName: "bg-row-parent",
    className: "bg-row-body",
    onlyOneExpanding: true,
    renderer: (row: any) => (
      <React.Fragment>
        <Row>
          <Col sm={12}>
            <Datatable
              data={dataRegistration}
              columns={COLUMNS_REGISTRATION_CUENTAS(columnModalSearchCuentas)}
              keyProp="reg_id"
              exportD={false}
              searchs={true}
              selectRows={false}
              optionSelectRow={null}
            />
          </Col>
        </Row>
      </React.Fragment>
    ),
    onExpand: (row: { gr_id: any; gr_desc: any; }, isExpand: any, rowIndex: any, e: any) => {
      if (isExpand) {
        fetchRegistration({gr_id:row.gr_id,gr_desc:row.gr_desc});
      }
    }
  };
}

export function EXPAND_ROW_GRADE_BOLETINES(
  fetchRegistration: { ({ gr_id, gr_desc,ar_literal }: any)},
  dataRegistration: any[],
  handlerExportBoletin:any,
  handlerSelectBoletin:any) {

  return {
    parentClassName: "bg-row-parent",
    className: "bg-row-body",
    onlyOneExpanding: true,
    renderer: (row: any) => (
      <React.Fragment>
        <Row>
        <Col sm ={12} className="text-right">
            <Button color="success" onClick={() => handlerExportBoletin(row)}>
                    Exportar boletin
                  </Button>
            </Col>
          <Col sm={12}>
            <Datatable
              data={dataRegistration}
              columns={COLUMNS_REGISTRATION_BOLETINES(handlerSelectBoletin)}
              keyProp="reg_id"
              exportD={false}
              searchs={true}
              selectRows={false}
              optionSelectRow={null}
            />
          </Col>
        </Row>
      </React.Fragment>
    ),
    onExpand: (row: { gr_id: any; gr_desc: any; ar_literal:any; per_consejero:any; cy_id:any }, isExpand: any, rowIndex: any, e: any) => {
      if (isExpand) {
        fetchRegistration({gr_id:row.gr_id,gr_desc:row.gr_desc,ar_literal:row.ar_literal, per_consejero:row.per_consejero, cy_id:row.cy_id});
      }
    }
  };
}

export function EXPAND_ROW_GRADE_HOUR(dataHours,fetchHour,handlerModalADDHour,rechargeData,loading,columnModalEditHour) {
  return {
    parentClassName: "bg-row-parent",
    className: "bg-row-body",
    onlyOneExpanding: true,
    renderer: (row: any) => (
      <React.Fragment>
        <Row>
        <Col sm={12} className="mt-2 mt-3 text-right">
        <ClipLoader css={override} size={23} color={"#36D7B7"} loading={loading} />
            <Button color="primary" className="mr-2" onClick={() => rechargeData()}>
              Recargar
            </Button>
          <Button color="success" onClick={() => handlerModalADDHour()}>
            Agregar
          </Button>
          </Col>
          <Col sm={12}>
            <Datatable
              data={dataHours}
              columns={COLUMNS_HOUR(columnModalEditHour)}
              keyProp="hr_id"
              exportD={false}
              searchs={false}
              selectRows={false}
              optionSelectRow={null}
            />
          </Col>
        </Row>
      </React.Fragment>
    ),
    onExpand: (row: { gr_id: any; gr_desc: any; }, isExpand: any, rowIndex: any, e: any) => {
      if (isExpand) {
        fetchHour({gr_id:row.gr_id,gr_desc:row.gr_desc});
      }
    }
  };
}

export function EXPAND_ROW_GRADE_ACONSEJERIA(dataTeacher: string | any[],fetchTeacher: (arg0: { gr_id: any; gr_desc: any; }) => void,handlerModalChangeConsejeria: any,handlerModalADDConsejeria: () => void) {
  return {
    parentClassName: "bg-row-parent",
    className: "bg-row-body",
    onlyOneExpanding: true,
    renderer: (row: any) => (
      <React.Fragment>
        <Row>
          <Col sm={12} className="mt-2 mt-3 text-right">
          {dataTeacher.length>0?null:
          <Button color="success" onClick={() => handlerModalADDConsejeria()}>
            Agregar
          </Button>}
          </Col>
          <Col sm={12} className="aconsejeria">
            <Datatable
              data={dataTeacher}
              columns={COLUMNS_ACONSEJERIA(handlerModalChangeConsejeria)}
              keyProp="per_id"
              exportD={false}
              searchs={false}
              selectRows={false}
              optionSelectRow={null}
            />
          </Col>
        </Row>
      </React.Fragment>
    ),
    onExpand: (row: { gr_id: any; gr_desc: any; }, isExpand: any, rowIndex: any, e: any) => {
      if (isExpand) {
        fetchTeacher({gr_id:row.gr_id,gr_desc:row.gr_desc});
      }
    }
  };
}

export function EXPAND_ROW_TEACHER(dataTeacher,fetchAsigTeacher,handlerModalADDHour,rechargeData,loading,columnModalEditHour) {
  return {
    parentClassName: "bg-row-parent",
    className: "bg-row-body",
    onlyOneExpanding: true,
    renderer: (row: any) => (
      <React.Fragment>
        <Row>
        <Col sm={12} className="mt-2 mt-3 mb-3 text-right">
        <ClipLoader css={override} size={23} color={"#36D7B7"} loading={loading} />
            <Button color="primary" className="mr-2" onClick={() => rechargeData()}>
              Recargar
            </Button>
          <Button color="success" onClick={() => handlerModalADDHour()}>
            Agregar
          </Button>
          </Col>
          <Col sm={12}>
            <Datatable
              data={dataTeacher}
              columns={COLUMNS_HOUR_ASITEACHER(columnModalEditHour)}
              keyProp="tas_id"
              exportD={false}
              searchs={false}
              selectRows={false}
              optionSelectRow={null}
            />
          </Col>
        </Row>
      </React.Fragment>
    ),
    onExpand: (row: { per_id: any; per_name: any; }, isExpand: any, rowIndex: any, e: any) => {
      if (isExpand) {
        fetchAsigTeacher({per_id:row.per_id,per_name:row.per_name});
      }
    }
  };
}